import { SWButton } from 'components/Buttons/SWButton';
import { FlexBox } from 'components/Containers/FlexBox';
import { Selector } from 'components/Form/Selectors/Selector';
import { MediumText } from 'components/Typography/MediumText';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  onChange: (arg0: any) => void;
  selectorOptions: Array<{ id: string; display: string }>;
  value?: string;
  handleSaveUpdates: () => Promise<void>;
  disableSaveEditButton: boolean;
  enableDarkTheme?: boolean;
}

export const TabHeader = ({
  onChange,
  selectorOptions,
  value,
  handleSaveUpdates,
  disableSaveEditButton,
  enableDarkTheme = false,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <FlexBox
      sx={{
        width: '100%',
        justifyContent: 'start',
        alignItems: 'center',
      }}
    >
      <MediumText
        text={t('displaying_tags_for')}
        sx={{
          color: enableDarkTheme
            ? ThemePalette.typography.wheat
            : ThemePalette.typography.black,
        }}
      />
      <Selector
        formControlSx={{
          padding: '0px 5px',
        }}
        onChange={(event: any) => {
          const selectedValue = event.target.value?.toString();

          onChange(selectedValue);
        }}
        value={value ?? ''}
        selectorOptions={selectorOptions}
        enableDarkTheme={enableDarkTheme}
      />

      <SWButton
        disabled={disableSaveEditButton}
        onClick={async () => {
          void handleSaveUpdates();
        }}
        sx={{
          ml: 'auto',
          '&.Mui-disabled': {
            backgroundColor: 'button.primary',
            color: '#C3C3C3',
            opacity: 0.9,
          },
        }}
      >
        {t('save_edits')}
      </SWButton>
    </FlexBox>
  );
};
